import React from 'react'
import './projectCard.css'
import Modal from '@material-ui/core/Modal'
import LinkIcon from '@material-ui/icons/Link'
import { Button } from '@material-ui/core'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

function ProjectCard({projectSrc,projectName,projectDesc,projectLink}) {

    const [modalStyle] = React.useState(getModalStyle);
    const [open, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    
    function getModalStyle() {
        const top = 50;
        const left = 50;
        const width = 40;
        return {
          top: `${top}%`,
          left: `${left}%`,
          width: `${width}vw`,
          transform: `translate(-${top}%, -${left}%)`,
        };
    }
    
    const body = (
        <div style = {modalStyle} className = 'projectModal'>
            <div className = 'projectCard_detail'>
                <LazyLoadImage effect="blur" className = 'projectCard_detail_lazy' src = {projectSrc} alt = 'my project'/>
                <h2>{projectName}</h2>
                <p>{projectDesc}</p>
                <Button variant = 'contained' color = 'secondary' href = {projectLink} target = '_blank'><LinkIcon/> <strong>Project Link</strong></Button>
            </div>
        </div>
    );

    const projectDetail = (e) => {
        e.preventDefault();
        handleOpen();
    }

    return (
        <div className = 'projectCard'>
            <LazyLoadImage effect="blur" className = 'projectCardImg_lazy' src = {projectSrc} alt = 'project' onClick = {projectDetail}/>
            <Modal
            open={open}
            onClose={handleClose}
            >
            {body}
            </Modal>
            <p>{projectName}</p>
        </div>
    )
}

export default ProjectCard
